module.exports = __webpack_public_path__ + "static/media/slide5.4c91ae2b.jpg";